import { StarsInfo } from '@ps/web-shared-ui';
import type { ComponentProps } from 'react';
import React from 'react';

import WarningIcon from '@swf/core/assets/icons/warning-triangle.svg';

import styles from './AccountInfoMessage.scss';

interface Props {
  children: React.ReactNode;
  type: Required<ComponentProps<typeof StarsInfo>>['type'];
}

const AccountWarningMessage = ({ children, type }: Props) => (
  <StarsInfo className={styles.message} type={type}>
    <WarningIcon className={styles.icon} />
    {children}
  </StarsInfo>
);

export default AccountWarningMessage;
